"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTransformedEventsResponseAllOfToJSON = exports.GetTransformedEventsResponseAllOfFromJSONTyped = exports.GetTransformedEventsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetTransformedEventsResponseAllOfFromJSON(json) {
    return GetTransformedEventsResponseAllOfFromJSONTyped(json, false);
}
exports.GetTransformedEventsResponseAllOfFromJSON = GetTransformedEventsResponseAllOfFromJSON;
function GetTransformedEventsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'events': (json['events'].map(_1.TransformedEventResponseFromJSON)),
    };
}
exports.GetTransformedEventsResponseAllOfFromJSONTyped = GetTransformedEventsResponseAllOfFromJSONTyped;
function GetTransformedEventsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'events': (value.events.map(_1.TransformedEventResponseToJSON)),
    };
}
exports.GetTransformedEventsResponseAllOfToJSON = GetTransformedEventsResponseAllOfToJSON;
